module.exports = __webpack_public_path__ + "6afe5efa72239d92b911c923c95ecaf4.svg";